export default {
  namespaced: true,
  state: {
    info: null,
    refresh: null,
    profile: null
  },
  getters: {
    isSignin(state) {
      return state.info != null
    },
    getProfile(state) {
      return state.profile
    },
    getSession(state) {
      return state
    },
    hasAnyRole: (state) => (roles) => {
      if (state.info == null) {
        return false
      }
      if (state.info.authorities == null) {
        return false
      }
      return !!state.info.authorities.filter(obj => {
        return roles.indexOf(obj) >= 0
      }).length
    },
    getTokenExpireTime(state) {
      if (state.info == null) {
        return null
      }
      let t = state.info.exp * 1000
      let d = new Date(t)
      d.setMinutes(d.getMinutes() - 50)
      return d
    },
    getRefreshTokenExpireTime(state) {
      return new Date(state.refresh.exp * 1000)
    }
  },
  mutations: {
    signin(state, obj) {
      state.info = obj.info
      state.refresh = obj.refresh
    },
    signout(state) {
      if (!state) { return }
      for (let k in state) {
        state[k] = null
      }
    },
    setProfile(state, profile) {
      // phone번호 강제로 - 삭제
      if (profile && profile.phone) {
        profile.phone = profile.phone.replace(/-/gi, '')
      }
      state.profile = profile
    }
  },
  actions: {
    signin({ commit }, obj) {
      commit('signin', obj)
    },
    signout({ commit }) {
      commit('signout')
    },
    setProfile({ commit }, profile) {
      commit('setProfile', profile)
    }
  }
}
